import { all } from 'redux-saga/effects';

import detailsSaga from './details/saga';
import followSaga from './follow/saga';
import allSaga from './all/saga';
import recommendedSaga from './recommended/saga';
import couponsSaga from './coupons/saga';
import affiliateCouponsSaga from './affiliateCoupons/saga';

export default function* saga() {
  yield all([detailsSaga(), followSaga(), allSaga(), recommendedSaga(), couponsSaga(), affiliateCouponsSaga()]);
}
